import { getDocument } from "./getDocument"

export function scrollWindowTo(
  id: string,
  options?: { scrollBehavior?: ScrollBehavior; offsetY?: number }
) {
  const top =
    window.scrollY +
    (getDocument()?.getElementById(id)?.getBoundingClientRect()?.top || 0) -
    (options?.offsetY ?? 0)
  window.scrollTo({
    top,
    behavior: options?.scrollBehavior || ("instant" as ScrollBehavior)
  })
}
